import { useTranslation } from "react-i18next";
import { Button, Dropdown, Form, Layout, message, Modal, Space, TableColumnsType, TableProps, Typography } from "antd";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import PageHeader from "../../../components/page-header/PageHeader";
import TableData from "../../../components/table-data/TableData";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routesConfig } from "../../../config/routes";
import { formatDateV2 } from "../../../utils/converDate";
import { CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined, LoadingOutlined, MoreOutlined, SaveOutlined, } from "@ant-design/icons";
import { FormInstance, MenuProps } from "antd/lib";
import {
  addMoocOrganization,
  deleteMoocOrganization,
  getAllOrganizationByFilter,
  getMoocOrganizationById,
  updateMoocOrganization,
} from "../../../service/category-management/organization-management";
import { isEmpty } from "lodash";
import FilterTable from "./components/filter-table/FilterTable";
import FormFilter from "./components/filter-group/FormFilter";
import DrawerCustom from "../../../components/drawer/Drawer";
import FormCreateOrganization from "./components/form-create-organization/FormCreateOrganization";
import { validateFieldCreate } from "./constants/data";
import "./organization-management.scss"

type OrganizationManagementProps = {
  title?: string;
};

const OrganizationManagement = (props: OrganizationManagementProps) => {
  const { t } = useTranslation();
  const { title } = props;
  const [form] = Form.useForm();
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [params, setParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState<string>("");
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedEdit, setIsOpenedEdit] = useState<boolean>(false);
  const [editId, setEditId] = useState<number>(0);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loadingForm, setLoadingForm] = useState<boolean>(false);
  const [dataOrganization, setDataOrganization] = useState<any>([]);
  const [dataOrganizationalDetails, setDataOrganizationalDetails] = useState<any>({});
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState<any>({
    topicIds: [],
    typeApproved: null,
    productionUnitId: null,
    approvedSendDateFrom: null,
    approvedSendDateTo: null,
    approvedDateFrom: null,
    approvedDateTo: null,
    typeProduction: null,
    userIds: null,
    status: false,
    historyStatus: null,
  });

  const organizationOptions: MenuProps["items"] = [
    {
      key: "1",
      label: t("Sửa tổ chức", "Sửa tổ chức"),
      icon: <EditOutlined />,
    },
    {
      key: "2",
      label: t("Xóa tổ chức", "Xóa tổ chức"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ];

  const dataColumns: TableColumnsType<any> = [
    {
      title: t("STT", "STT"),
      dataIndex: "stt",
      key: "stt",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên tổ chức", "Tên tổ chức"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 30,
      className: "title-sequence",
      render: (_: any, record) => {
        return (
          <div className="table-organization cursor-pointer">
            <div>
              <a
                className="organization-name"
                onClick={() =>
                  navigate(
                    `${routesConfig.organizationManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                      },
                    }
                  )
                }
              >
                {record.name}
              </a>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Mã tổ chức", "Mã tổ chức"),
      dataIndex: "code",
      key: "code",
      className: "title-sequence",
      width: 20,
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any, index: number) => {
        return record.createdDate ? formatDateV2(record.createdDate) : null;
      },
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() =>
                  navigate(
                    `${routesConfig.organizationManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                        idEdit: record?.id,
                      },
                    }
                  )
                }
              >
                <EyeOutlined />
              </a>

              <Dropdown
                menu={{
                  items: organizationOptions,
                  onClick: ({ key }) => {
                    if (key === "1") {
                      getOrganizationUpdate(record.id);
                      handleOpenEdit(record.id);
                    }
                    if (key === "2") {
                      Modal.confirm({
                        title: t("Xóa tổ chức", "Xóa tổ chức"),
                        content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                        onOk: () => deleteOrganization(record),
                        centered: true,
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      fixed: "right",
      width: 20,
    },
  ];

  const listBreadcrumb = [
    {
      title: t("Quản lý danh mục / Quản lý khác", "Quản lý danh mục / Quản lý khác"),
    },
    {
      title: <span className="style-title">{t("Danh sách tổ chức", "Danh sách tổ chức")}</span>,
    },
  ];

  // Get data Organization
  const getAllOrganization = (data?: any) => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      createdDateFrom: filterData.createdDateFrom ? filterData.createdDateFrom : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort: isEmpty(fieldSortOrder) || isEmpty(statusOrder) ? ["created_date, desc"] : [`${fieldSortOrder},${statusOrder}`],
    };
    getAllOrganizationByFilter(dataReq)
      .then((res) => {
        if (res.status === 200) {
          setDataOrganization(res.data?.data?.content);
          setTotalRecords(res.data?.data?.totalElements);
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }
      })
      .catch((err) => {
        if (err.response?.status === 400) {
          navigate("/error/403");
        } else {
          console.error(err);
        }
        setLoading(false);
      }).finally(() => {setLoading(false);});
  };

  // Filter Search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const clearFilter = (form: FormInstance) => {
    form.resetFields();
    setFilterData({
      user: null,
      createdDateFrom: null,
      createdDateTo: null,
    });
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setPageNumber(1);
      getAllOrganization();
    }
  };

  const handleSubmitSearch = () => {
    setPageNumber(1);
    getAllOrganization();
  };

  const handleFinish = (values: any) => {
    setPageNumber(1);
    setFilterData({
      ...filterData,
      user: values?.user,
      createdDateFrom: values?.time ? (values?.time[0]).add(1, "day").toISOString() : null,
      createdDateTo: values?.time ? (values?.time[1]).add(1, "day").toISOString() : null,
    });
  };

  // Get Organization to edit
  const getOrganizationUpdate = async (id: number) => {
    setLoadingForm(true);
    await getMoocOrganizationById(id)
      .then((res) => {
        const { data } = res.data;
        setDataOrganizationalDetails(data);
        setTimeout(() => {
          setLoadingForm(false);
        }, 333);
      })
      .catch((err) => {
        setLoadingForm(false);
        console.error(err);
      });
  };

  // Modal create | edit
  const handleOpenCreate = () => {
    setIsOpened(true);
  };

  const handleOpenEdit = (id: number) => {
    setEditId(id);
    setIsOpened(true);
    setIsOpenedEdit(true);
  };

  const handleClose = () => {
    setIsOpened(false);
    setIsOpenedEdit(false);
    form.resetFields();
  };

  const handleCreateAndEdit = () => {
    Modal.confirm({
      title: !isOpenedEdit ? t("Thêm mới tổ chức", "Thêm mới tổ chức") : t("Chỉnh sửa tổ chức", "Chỉnh sửa tổ chức"),
      content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu"),
      onOk: () => form.submit(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  };

  const onFinishCreate = async (values: any) => {
    if (Object.keys(values).length > 0) {
      if (isOpenedEdit) {
        const dataPayload = {
          id: editId,
          name: values.name.trim(),
          code: values.code.trim(),
          typeOrganization: values.typeOrganization,
        };
        setIsSaving(true);
        try {
          await updateMoocOrganization(dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Cập nhật tổ chức thành công!", "Cập nhật tổ chức thành công!"));
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllOrganization();
          });
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      } else {
        const dataPayload = {
          id: null,
          name: values.name.trim(),
          code: values.code.trim(),
          typeOrganization: values.typeOrganization,
        };
        setIsSaving(true);
        try {
          await addMoocOrganization(dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Thêm mới tổ chức thành công!", "Thêm mới tổ chức thành công!"));
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllOrganization();
          });
        } catch (err) {
          console.error(err);
          setIsSaving(false);
        } finally {
          setIsSaving(false);
        }
      }
    }
  };

  // Delete Organization
  const deleteOrganization = async (organization: any) => {
    try {
      await deleteMoocOrganization(organization.id).then((res) => {
        if (res.status === 200) {
          message.success(t("Xóa tổ chức thành công!", "Xóa tổ chức thành công!"));
          getAllOrganization();
        }
      });
    } catch (err) {}
  };

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // useEffect
  useEffect(() => {
    if (Object.keys(dataOrganizationalDetails)?.length > 0) {
      form.setFieldsValue({
        name: dataOrganizationalDetails?.name,
        code: dataOrganizationalDetails?.code,
        typeOrganization: dataOrganizationalDetails?.typeOrganization,
      });
    }
  }, [dataOrganizationalDetails]);

  useEffect(() => {
    getAllOrganization();
  }, [pageNumber, pageSize, filterData, statusOrder]);

  return (
    <Layout className="page-header-group">
      <Form.Provider onFormFinish={(name, { values, forms }) => {
          if (name === "createOrganization") {
            const { createOrganization } = forms;
            const data = createOrganization.getFieldsValue(validateFieldCreate);
            onFinishCreate(data);
          }
        }}
      >
        <div className={`page-header-group--layout ${showFilter ? "open-filter" : ""}`}>
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterTable
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              handleChangeInput={handleChangeInput}
            />
          </div>
            <FormFilter
              clearFilter={clearFilter}
              onFinish={handleFinish}
              showFilter={showFilter}
            />
          </div>

          <TableData
            pagination={true}
            pageSize={pageSize}
            hideSelection={false}
            dataTable={dataOrganization}
            pageNumber={pageNumber}
            dataColumns={dataColumns}
            loadingTable={loading}
            setPageSize={setPageSize}
            scroll={{ x: 1500, y: 800 }}
            setPageNumber={setPageNumber}
            totalRecords={totalRecords}
            handleTableChangeProps={handleTableChange}
            setSelectedRowKeysProps={setSelectedRowKeys}
          />

        <DrawerCustom title={isOpenedEdit ? t("Chỉnh sửa tổ chức", "Chỉnh sửa tổ chức") : t("Thêm mới tổ chức", "Thêm mới tổ chức")}
          open={isOpened}
          onClose={handleClose}
          extraNode={
            <Space>
              <Button onClick={handleClose} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button className="btn btn-primary" htmlType="submit" onClick={handleCreateAndEdit} disabled={isSaving}>
                {isSaving ? <LoadingOutlined /> : <SaveOutlined />}
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
          widthDrawer={690}
        >
          <FormCreateOrganization form={form} loadingForm={loadingForm} />
        </DrawerCustom>
      </Form.Provider>
    </Layout>
  );
};
export default OrganizationManagement;
